import React from 'react';
import SubscriberConfirmationDialog from '../subscriptions/components/SubscriberConfirmationDialog';
import ShowNotificationDialog from './ShowNotificationDialog';
import Selectors from '../hooks/selectors';

const NotificationDialogs = ({ theme }) => {
  const { allowRead, allowSubscribe } = Selectors.useNotificationDialogs();

  return (
    <>
      {allowRead && (<ShowNotificationDialog theme={theme} />)}
      {allowSubscribe && (<SubscriberConfirmationDialog theme={theme} />)}
    </>
  );
};

export default NotificationDialogs;
